@if(type == 'standard'){

  <div class="d-flex ion-align-items-center">
    <div style="flex: 0.2">
      <div class="d-flex ion-align-items-center gap-2"
           (click)="onBack()">
        <div class="d-flex ion-align-items-center">
          <div style="font-size: 28px;" class="material-symbols-outlined">keyboard_backspace</div>
        </div>
      </div>
    </div>
    <div style="flex: 0.8" class="ion-text-center">
      <span class="ts-caption-bold">{{title}}</span>
    </div>
    <div style="flex:0.2" class="d-flex ion-justify-content-end">
      <ng-content select="[action]"></ng-content>
    </div>
  </div>

} @else {
  <ion-fab-button class="white"
                  (click)="onBack()">
    <span class="material-symbols-outlined">arrow_back</span>
  </ion-fab-button>
}

